import z from 'zod'
import { nullSafeFirestoreTimestamp, nullSafeString } from '../shared/schema'

export const schema = z.object({
  clickWrapId: nullSafeString(''),
  acceptedAt: nullSafeFirestoreTimestamp(new Date()),
})

export const empty = Object.freeze(
  schema.parse({
    clickWrapId: '',
    acceptedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreClickWrapAccepted extends z.infer<typeof schema> {}
